export default __webpack_public_path__ + "static/media/Instagram.480881be.png";